export const CREATE_FIRM_ENABLER = 'createFirm';
export const DELETE_COMPANY_ENABLER = 'deleteCompany';
export const DELETE_MEASUREMENT_DATES_ENABLER = 'deleteMeasurementDates';
export const DOCUMENTS_ENABLER = 'documents';
export const EXCEL_REPORTS_ENABLER = 'excelReports';
export const PROCESS_MANAGEMENT_ENABLER = 'processManagement';
